import axiosInstance from "./axiosInstance";

export const getUserProfile = async () => {
  return await axiosInstance.get("/user/profile");
};

export const updateName = async (data) => {
  return await axiosInstance.put("/user/update-name", data);
};


export const updateProfilePicture = async (formData) => {
  return await axiosInstance.put("/user/update-profile-picture", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
